import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-attachment1-icon',
  templateUrl: './general-attachment1.component.html'
})
export class GeneralAttachment1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
